import { CssRender } from 'css-render'
import { c, cB } from "naive-ui";
export default c([
  cB(
    "input-number-suffix",
    `
    display: inline-block;
    margin-right: 10px;
  `
  )
])
